import React from 'react';
import { Link } from 'react-router-dom';

const NoticeCard = ({ notice }) => {
  return (
    notice && (
      <a
        href={`https://www.aniplustv.com/customer/1?idx=${notice.idx}&c=4|5`}
        target="_blank"
        className="item"
      >
        <span className="date">{notice.writeday.toString().split('T')[0]}</span>
        <span className="txt">{notice.title}</span>
      </a>
    )
  );
};

export default NoticeCard;
